import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter, MomentDateModule } from '@angular/material-moment-adapter';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { TextInputComponent } from './base/text-input/text-input.component';
import { TextInputComponentEx } from './base/text-input-ex/text-input-ex.component';
import { ObjectInputComponent } from './base/object-input/object-input.component';
import { ObjectInputComponentEx } from './base/object-input-ex/object-input-ex.component';
import { SelectControlComponent } from './base/select-control/select-control.component';
import { BlockControlComponent } from './base/block-control/block-control.component';
import { FieldComponent } from './base/field/field.component';
import { FieldAComponent } from './base/field/fieldA.component';
import { FieldBComponent } from './base/field/fieldB.component';
import { MsgBoxComponent } from './base/msgbox/msgbox.component';
import { TabComponent } from './base/tab/tab.component';
import { CaptionComponent } from './base/caption/caption.component';
import { OptionalComponent } from './base/optional/optional.component';
import { HidableTextComponent } from './base/hidable-text/hidable-text.component';
import { InfoTooltipComponent } from './base/info-tooltip/info-tooltip.component';
import { TableComponent } from './base/table/table.component';
import { PhotoComponent } from './dev/photo/photo.component';
import { PhotoWizardComponent } from './dev/photo-wizard/photo-wizard.component';
import { TabletSignComponent } from './dev/tablet-sign/tablet-sign.component';
import { FingerprintComponent } from './dev/fingerprint/fingerprint.component';
import { WacomSignComponent } from './dev/wacom-sign/wacom-sign.component';
import { PassVerifyComponent } from './dev/pass-verify/pass.verify.component';
import { ElementResizeDirective } from './base/directive/element-resize.directive';
import { TableEditorComponent } from './base/table-editor/table-editor.component';
import { TableEditorDialogBoxComponent } from './base/table-editor-dialog-box/table-editor-dialog-box.component';
import { VirtualKeyboardComponent } from './base/virtual-keyboard/virtual-keyboard.component';
import { VirtualKeyboardKeyComponent } from './base/virtual-keyboard-key/virtual-keyboard-key.component';
import { SearchBarComponent } from './base/search-bar/search-bar.component';
import { SearchFieldComponent } from './base/search-field/search-field.component';
import { CheckboxComponent } from './base/checkbox/checkbox.component';
import { PassScanChipComponent } from './dev/scan-chip/pass.scan.chip.component';
import { PassFpVerifyComponent } from './dev/scan-chip/pass.fp.verify.component';
import { PassScanMrzComponent } from './dev/scan-mrz/pass.scan.mrz.component';
import { PrintableComponent } from './base/printable/printable.component';
import { BarcodeDirective } from './base/directive/barcode.directive';
import { RequestViewComponent } from './base/form-view/request-view/request-view.component';
import { RequestViewContentDirective } from './base/form-view/request-view/request-view-content-directive';
import { QrReaderComponent } from './dev/qrreader/qrreader.component';
import { TabletSignPhotoWizardComponent } from './dev/tablet-sign-photo-wizard/tablet-sign-photo-wizard.component';
import { PhotoUploadComponent } from './dev/photo-upload/photo-upload.component';
import { DateSettingComponent } from './dev/date-setting/date-setting.component';
import { VideoStreamDialogComponent } from './service/stubs/video-stream-dialog/video-stream-dialog.component';
import { BatteryStateMonitorComponent } from './dev/battery-state-monitor/battery-state-monitor.component';
import { FieldDateRangeComponent } from './base/field/fieldDateRange.component';
import { SvgDragDirective } from './base/directive/svg-drag.directive';
import { SvgParentDragDirective } from './base/directive/svg-parent-drag.directive';
import { TestClassDirective } from './base/directive/test-class.directive';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InfoComponent } from './dev/info/info.component';
import { I18NPipe } from '../pipes/i18n.pipe';

@NgModule({
  declarations: [
    PassVerifyComponent,
    PassScanChipComponent,
    PassFpVerifyComponent,
    PassScanMrzComponent,
    DateSettingComponent,
    TextInputComponent,
    TextInputComponentEx,
    ObjectInputComponent,
    ObjectInputComponentEx,
    SelectControlComponent,
    BlockControlComponent,
    FieldComponent,
    FieldAComponent,
    FieldBComponent,
    FieldDateRangeComponent,
    MsgBoxComponent,
    TabComponent,
    CaptionComponent,
    OptionalComponent,
    HidableTextComponent,
    InfoTooltipComponent,
    TableComponent,
    PhotoComponent,
    PhotoWizardComponent,
    TabletSignComponent,
    FingerprintComponent,
    WacomSignComponent,
    ElementResizeDirective,
    BarcodeDirective,
    SvgDragDirective,
    SvgParentDragDirective,
    TestClassDirective,
    TableEditorComponent,
    TableEditorDialogBoxComponent,
    VirtualKeyboardComponent,
    VirtualKeyboardKeyComponent,
    SearchBarComponent,
    SearchFieldComponent,
    CheckboxComponent,
    PrintableComponent,
    RequestViewComponent,
    RequestViewContentDirective,
    QrReaderComponent,
    TabletSignPhotoWizardComponent,
    PhotoUploadComponent,
    DateSettingComponent,
    VideoStreamDialogComponent,
    BatteryStateMonitorComponent,
    TestClassDirective,
    InfoComponent,
    I18NPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    MatTooltipModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    MatDatepickerModule,
    MomentDateModule,
    NgxMatMomentModule,
    MatTabsModule,
    MatExpansionModule,
    MatProgressBarModule,
  ],
  exports: [
    PassVerifyComponent,
    PassScanChipComponent,
    PassScanMrzComponent,
    TextInputComponent,
    TextInputComponentEx,
    ObjectInputComponent,
    ObjectInputComponentEx,
    SelectControlComponent,
    BlockControlComponent,
    FieldComponent,
    FieldAComponent,
    FieldBComponent,
    FieldDateRangeComponent,
    MsgBoxComponent,
    TabComponent,
    CaptionComponent,
    OptionalComponent,
    HidableTextComponent,
    InfoTooltipComponent,
    TableComponent,
    PhotoComponent,
    PhotoWizardComponent,
    TabletSignComponent,
    FingerprintComponent,
    WacomSignComponent,
    ElementResizeDirective,
    BarcodeDirective,
    VirtualKeyboardComponent,
    VirtualKeyboardKeyComponent,
    SearchBarComponent,
    SearchFieldComponent,
    CheckboxComponent,
    PrintableComponent,
    RequestViewComponent,
    RequestViewContentDirective,
    QrReaderComponent,
    TabletSignPhotoWizardComponent,
    PhotoUploadComponent,
    DateSettingComponent,
    BatteryStateMonitorComponent,
    TestClassDirective,
    InfoComponent,
    I18NPipe,
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['YYYY-MM-DD'],
        },
        display: {
          dateInput: 'YYYY-MM-DD',
          monthYearLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class ControlsModule {}
